import { useEffect, useState } from "react";
import { useWindow } from "../../hooks";
import Button from "./Button";

import { TiArrowBack } from "react-icons/ti";
import { debounce } from "../../helpers";

const NavigationButton = ({
  className,
  backLabel,
  nextLabel,
  component,
  hideBack = false,
  hideNext = false,
  nextDisabled = false,
  backDisable = false,
  isLastStep = false,
  nextStyle = {},
  onBackClick = () => {},
  onNextClick = () => {},
}) => {
  const { windowSize } = useWindow();
  const [isShowText, setIsShowText] = useState(false);

  useEffect(() => {
    if (isLastStep) debounce(() => setIsShowText(true), 200)();
    else setIsShowText(false);
  }, [isLastStep]);

  const check = isLastStep ? isShowText : true;
  return (
    <div
      className={`footer-section ${className}`}
      style={{ margin: "5px 0px" }}
    >
      {isShowText && component}

      <div className="btn-area mb-1 align-items-end">
        {!hideBack && (
          <Button
            {...(windowSize?.width < 500 && isLastStep
              ? { icon: <TiArrowBack />, style: { padding: "7px 20px" } }
              : { label: backLabel })}
            disabled={backDisable}
            onClick={onBackClick}
            variant="secondary"
            size="medium"
          />
        )}
        {!hideNext && (
          <Button
            disabled={nextDisabled}
            label={check ? nextLabel : "Saving..."}
            onClick={onNextClick}
            variant="primary"
            size="medium"
            style={{
              ...nextStyle,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default NavigationButton;
